var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
var renderDatePicker = /** @class */ (function (_super) {
    __extends(renderDatePicker, _super);
    function renderDatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (e) {
            if (e && e.target) {
                _this.props.input.onChange(e);
            }
        };
        return _this;
    }
    renderDatePicker.prototype.render = function () {
        var _a = this.props, input = _a.input, placeholder = _a.placeholder, _b = _a.meta, touched = _b.touched, error = _b.error;
        return (_jsxs("div", __assign({ className: 'input profileDate' }, { children: [_jsx(InputMask, __assign({ mask: "99-99-9999", value: input.value || '', onChange: this.handleChange }, { children: function (inputProps) { return _jsx("input", __assign({}, inputProps, { type: 'tel', maxLength: '20', name: 'Birthdate', placeholder: placeholder })); } })), touched && error && _jsx("span", { children: error })] })));
    };
    renderDatePicker.propTypes = {
        input: PropTypes.shape({
            onChange: PropTypes.func.isRequired,
            value: PropTypes.any.isRequired,
        }).isRequired,
        meta: PropTypes.shape({
            touched: PropTypes.bool,
            error: PropTypes.bool,
        }),
        placeholder: PropTypes.string,
    };
    return renderDatePicker;
}(React.Component));
export default renderDatePicker;



// WEBPACK FOOTER //
// ./src/components/shared/renderDatePicker.jsx